import { cn } from '@/lib/utils';

/**
 * 매거진 섹션 디바이더 — 가는 헤어라인 + 중앙 다이아몬드.
 * 페이지 안에서 단락이 바뀔 때 한 번씩 사용. 너무 자주 쓰면 효과가 죽는다.
 */
export function Ornament({ className, gold = true }: { className?: string; gold?: boolean }) {
  const color = gold ? 'text-gold' : 'text-ink/30';
  return (
    <div className={cn('flex items-center justify-center gap-3', className, color)} aria-hidden>
      <span className="h-px w-16 bg-current" />
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 0L14 7L7 14L0 7L7 0Z" fill="currentColor" opacity="0.85" />
        <path d="M7 3L11 7L7 11L3 7L7 3Z" fill="hsl(40 56% 98%)" />
        <circle cx="7" cy="7" r="1.2" fill="currentColor" />
      </svg>
      <span className="h-px w-16 bg-current" />
    </div>
  );
}

/** 짧은 가로 헤어라인 — 키커 옆 또는 단락 사이에 둔다. */
export function Hairline({ className, gold = false }: { className?: string; gold?: boolean }) {
  return (
    <span
      aria-hidden
      className={cn('inline-block h-px', gold ? 'bg-gold' : 'bg-ink/15', className)}
    />
  );
}

/** 매거진 키커 — 모든 섹션 위에 얹는 골드 라벨. */
export function Kicker({
  children,
  className,
  withBar = true,
}: {
  children: React.ReactNode;
  className?: string;
  withBar?: boolean;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-3 text-[10.5px] font-medium uppercase text-gold',
        className,
      )}
      style={{ letterSpacing: '0.32em' }}
    >
      {withBar && <span className="h-px w-6 bg-gold" />}
      {children}
    </span>
  );
}

/** 섹션 번호 — 01., 02., 03. 매거진 챕터 표기 */
export function SectionNumber({ n, className }: { n: string; className?: string }) {
  return (
    <span
      className={cn('font-display text-sm tabular-nums text-gold', className)}
      style={{ letterSpacing: '0.18em' }}
    >
      {n}
    </span>
  );
}
